// extracted by mini-css-extract-plugin
export default {"banner":"HomeBanner_banner__u-7d6","banner__bgImg":"HomeBanner_banner__bgImg__Nfeh8"};